'use strict';

module.exports = require('./lib/React');



/*****************
 ** WEBPACK FOOTER
 ** /usr/src/sentry/~/react/react.js
 ** module id = 1
 ** module chunks = 0
 **/